
// In src/components/search/TutorCard.tsx
import React, { useMemo } from 'react'; // Import useMemo
import { UserDetails } from '../../types/schemas/abc';
import { getFirstName } from '../../utils/name';
import { 
  TutorCardWrapper, 
  TutorImage, 
  TutorInfo,
  TutorName, 
  TutorCredentials,  // 👈 Import new component
  TutorDescription,
  TagWrap,
  Tag,
  NameAndPriceWrapper,
  CornerTag,
  PriceDisplay,
  CornerTagContainer, // 👈 Import new component
} from '../../styles/search/search.style';
import { styled } from '../../styles/stitches.config';
import { calculateFinalCost } from '../../utils/pricing';




interface TutorCardProps {
  tutor: UserDetails;
  parent: UserDetails;
}

export const TutorCard: React.FC<TutorCardProps> = ({ tutor, parent }) => {
  console.log(tutor);

  // In TutorDetailView.tsx, with your other useMemo hooks


  const parentRequiredSubjectsSet = useMemo(() => {
    if (!parent?.subjects) return new Set<string>();
  
    return new Set(parent.subjects);
  }, [parent?.subjects]);

  // This hook builds the credentials string, handling the optional classification
  const credentials = useMemo(() => {
    const parts = [];
    if (tutor.degreeCourse) parts.push(tutor.degreeCourse);
    // if (tutor.university) parts.push(`at ${tutor.university}`);
    
    const mainCredentials = parts.join(' ');

    if (tutor.classification) {
      return `${mainCredentials} • ${tutor.classification}`;
    }
    return mainCredentials;
  }, [tutor.degreeCourse, tutor.university, tutor.classification]);

  const finalPrice = useMemo(() => {
    if (!tutor.hourlyRate) return null;
    return calculateFinalCost(tutor.hourlyRate);
  }, [tutor.hourlyRate]);

  const promoTags = useMemo(() => {
    const tags = [];
    if (tutor.offersFreeFirstLesson) {
      tags.push({ text: '1st Lesson Free', color: 'green' as const });
    }
    if (tutor.offersFreeIntroCall) {
      tags.push({ text: 'Free Intro Call', color: 'blue' as const });
    }
    return tags; // Returns an array, which could be empty or have one or two tags
  }, [tutor.offersFreeFirstLesson, tutor.offersFreeIntroCall]);

  return (
    // {tutor.offersFreeIntroCall}

    <TutorCardWrapper>
      {promoTags.length > 0 && (
        <CornerTagContainer>
          {promoTags.map((tag) => (
            <>
          <CornerTag key={tag.text} color={tag.color}>
              {tag.text}
            </CornerTag>
            </>
          ))}
        </CornerTagContainer>
      )}
      <TutorImage
        src={tutor.profilePhotoUrl || '/default-avatar.png'}
        alt={getFirstName(tutor.name) || 'Tutor'}
      />
      <TutorInfo>
      <NameAndPriceWrapper>
        <TutorName>
  {getFirstName(tutor.name) || 'Tutor'}
  {tutor?.university && ` (${tutor.university})`}
  </TutorName>
  <PriceDisplay>
    {`£${finalPrice}/hr`}
  </PriceDisplay>
</NameAndPriceWrapper>


        
        {/* We only render credentials if they exist */}
        {credentials && <TutorCredentials>{credentials}</TutorCredentials>}

        {tutor.subjects && tutor.subjects.length > 0 && (
          <TagWrap css={{ marginTop: 'auto', paddingTop: '1rem', width: '100%', marginLeft: 0, marginRight: 0 }}>
            {tutor.subjects.map((subject) => {

              const isMatch = parentRequiredSubjectsSet.has(subject);
              return (
              <Tag key={subject} isMatch={isMatch}>{subject}</Tag>
            )
            })}
          </TagWrap>
        )}

        {/* The description is also optional */}
        {tutor.description && <TutorDescription>{tutor.description}</TutorDescription>}
      </TutorInfo>
    </TutorCardWrapper>
  );
};